import dayjs from 'dayjs';
import parsePhoneNumber from 'libphonenumber-js';
import { getI18n } from 'react-i18next';

export enum Formatter {
  PHONE = 'phone',
  DATE = 'date',
}

export const phoneFormatter = (value: string) =>
  parsePhoneNumber(value)?.formatInternational() || '';

export const dateFormatter = (
  value: string,
  lng?: string,
  options?: {
    inputFormat?: string;
    format?: string;
    withToday?: boolean;
    withTomorrow?: boolean;
    isSmall?: boolean;
  }
) => {
  const d = dayjs(value, options?.inputFormat);
  const today = dayjs().startOf('day');
  const tomorrow = today.add(1, 'day');

  const { t } = getI18n();

  if (options?.withToday && d.isSame(today, 'day')) {
    return options?.isSmall ? t('todaySmall') : t('today');
  }

  if (options?.withTomorrow && d.isSame(tomorrow, 'day')) {
    return options?.isSmall ? t('tomorrowSmall') : t('tomorrow');
  }

  return dayjs(value, options?.inputFormat).format(
    options?.format || 'DD.MM.YYYY'
  );
};
